import { db } from '../config/firebase';
import {
    collection, doc, getDocs, setDoc, writeBatch, serverTimestamp,
} from 'firebase/firestore';

const COLLECTION = 'fondosFci';

export const DEFAULT_FONDOS_FCI = [
    { nombre: 'IAM RENTA CRECIMIENTO CLASE A', sociedadGerente: 'IAM', moneda: 'Pesos', plazoLiquidacionDefault: 'T+0' },
    { nombre: 'IAM RENTA CRECIMIENTO CLASE B', sociedadGerente: 'IAM', moneda: 'Pesos', plazoLiquidacionDefault: 'T+1' },
    { nombre: 'IAM AHORRO PESOS CLASE A', sociedadGerente: 'IAM', moneda: 'Pesos', plazoLiquidacionDefault: 'T+0' },
    { nombre: 'IAM AHORRO PESOS CLASE B', sociedadGerente: 'IAM', moneda: 'Pesos', plazoLiquidacionDefault: 'T+0' },
    { nombre: 'AXIS ESTRATEGIA 28 CLASE A', sociedadGerente: 'AXIS', moneda: 'Pesos', plazoLiquidacionDefault: 'T+1' },
    { nombre: 'AXIS ESTRATEGIA 28 CLASE B', sociedadGerente: 'AXIS', moneda: 'Pesos', plazoLiquidacionDefault: 'T+1' },
    { nombre: 'MEGAQM PESOS CLASE A', sociedadGerente: 'MEGAQM', moneda: 'Pesos', plazoLiquidacionDefault: 'T+0' },
    { nombre: 'MEGAQM PESOS CLASE B', sociedadGerente: 'MEGAQM', moneda: 'Pesos', plazoLiquidacionDefault: 'T+0' },
];

export const fondoSlug = (nombre) => (nombre || '')
    .toUpperCase()
    .normalize('NFD').replace(/[̀-ͯ]/g, '')
    .replace(/[^A-Z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const seedDefaultFondosFci = async () => {
    const colRef = collection(db, COLLECTION);
    const snap = await getDocs(colRef);
    const existing = new Set(snap.docs.map(d => d.id));
    const batch = writeBatch(db);
    let created = 0;
    DEFAULT_FONDOS_FCI.forEach(f => {
        const id = fondoSlug(f.nombre);
        if (existing.has(id)) return;
        const ref = doc(colRef, id);
        batch.set(ref, {
            nombre: f.nombre,
            sociedadGerente: f.sociedadGerente,
            moneda: f.moneda,
            plazoLiquidacionDefault: f.plazoLiquidacionDefault,
            active: true,
            createdAt: serverTimestamp(),
            updatedAt: serverTimestamp(),
        });
        created += 1;
    });
    if (created > 0) await batch.commit();
    return created;
};

export const upsertFondoFci = async (fondo) => {
    const id = fondoSlug(fondo.nombre);
    if (!id) throw new Error('El nombre del fondo es obligatorio.');
    const ref = doc(db, COLLECTION, id);
    await setDoc(ref, {
        nombre: fondo.nombre,
        sociedadGerente: fondo.sociedadGerente || '',
        moneda: fondo.moneda || 'Pesos',
        plazoLiquidacionDefault: fondo.plazoLiquidacionDefault || 'T+0',
        active: fondo.active !== false,
        updatedAt: serverTimestamp(),
        ...(fondo.createdAt ? {} : { createdAt: serverTimestamp() }),
    }, { merge: true });
    return id;
};

export const findFondoByNombre = (fondos, nombre) => {
    if (!nombre) return null;
    const norm = nombre.trim().toUpperCase();
    return fondos.find(f => (f.nombre || '').trim().toUpperCase() === norm) || null;
};
